import { render, staticRenderFns } from "./DossierScriptEditProperties.vue?vue&type=template&id=8cefdda2&scoped=true&"
import script from "./DossierScriptEditProperties.vue?vue&type=script&lang=ts&"
export * from "./DossierScriptEditProperties.vue?vue&type=script&lang=ts&"
import style0 from "./DossierScriptEditProperties.vue?vue&type=style&index=0&id=8cefdda2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cefdda2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8cefdda2')) {
      api.createRecord('8cefdda2', component.options)
    } else {
      api.reload('8cefdda2', component.options)
    }
    module.hot.accept("./DossierScriptEditProperties.vue?vue&type=template&id=8cefdda2&scoped=true&", function () {
      api.rerender('8cefdda2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dossier/DossierScriptEditProperties.vue"
export default component.exports